<div data-qa-block="options">
  <p class="required-marker block_title" translate data-qa="block-title">{{ title }}</p>
  <div class="setting_description">
    <div
      *ngIf="!details || !details?.length; else value"
      class="ui-kit-grey-text"
      translate
      data-qa="empty-list-text"
    >
      {{ placeholder }}
    </div>
    <ng-template #value>
      <div data-qa="options-list">{{ details }}</div>
    </ng-template>
  </div>
  <button
    class="select_params"
    data-qa-button="select-options"
    (click)="callCreateModal(modalId)"
    translate
  >
    group.account.select
  </button>
</div>
